var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3,
  clipPath: "url(#move-icon_svg__a)",
  stroke: "#373F41",
  strokeWidth: 0.833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.364 6.243 3.121-3.122 3.122 3.122M15.607 18.728l-3.122 3.121-3.121-3.121M12.485 3.122v7.283M12.485 21.85v-7.284"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "move-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(-45 15.071 6.243)",
  d: "M0 0h17.657v17.657H0z"
})))));
export { SvgMoveIcon as ReactComponent };
export default __webpack_public_path__ + "31bee4ca20c69b8a664a6e1ca789167c.svg";